import { ToastViewport as ToastViewportOg, useSafeArea } from '@my/ui'

export const ToastViewport = () => {
  const { top, right, left } = useSafeArea()
  return <ToastViewportOg zIndex={100_000} top={top + 5} left={left} right={right} />
}
